import {
  SET_EXPORT_MESSAGE
} from "typeConstants";
import { exports as initialState } from "reducers/initialState.tsx";

const exports = (state = initialState, action) => {
  switch (action.type) {
    case SET_EXPORT_MESSAGE:
      return {
        ...state,
        runningExports: {...action.payload},
      };
    default:
      return state;
  }
};

export default exports;
